/**
 * Domain Icon Renderer - AD domain node icon
 *
 * Renders a simple building/shield icon to represent domain boundaries.
 */

import { getIconConfig } from '@/components/icons/nodeIcons/config/iconConfig';
import { getThemeColors } from '@/components/icons/nodeIcons/config/themeColors';
import {
  calculateIconPosition,
  drawCircleBackground,
  setupCanvas,
} from '@/components/icons/nodeIcons/renderers/base';

export const createDomainIconDataURL = (
  currentTheme: 'light' | 'dark',
  isHighlighted: boolean = false
): string => {
  const config = getIconConfig('domain');
  const colors = getThemeColors('domain', currentTheme, isHighlighted);
  const { canvas, ctx, size, centerX, centerY } = setupCanvas(config);

  drawCircleBackground(ctx, centerX, centerY, size, config.scale, colors);

  const { x, y, scale } = calculateIconPosition(centerX, centerY, size, config);

  ctx.save();
  ctx.translate(x, y);
  ctx.scale(scale, scale);
  ctx.fillStyle = colors.icon;

  // Base building
  ctx.beginPath();
  ctx.moveTo(5, 24);
  ctx.lineTo(5, 11);
  ctx.lineTo(21, 6);
  ctx.lineTo(21, 24);
  ctx.closePath();
  ctx.fill();

  // Door
  ctx.fillStyle =
    currentTheme === 'light' ? 'rgba(255,255,255,0.85)' : 'rgba(30,30,30,0.85)';
  ctx.fillRect(11.5, 17.5, 3, 6.5);

  // Windows
  const windowColor =
    currentTheme === 'light' ? 'rgba(255,255,255,0.7)' : 'rgba(30,30,30,0.65)';
  ctx.fillStyle = windowColor;
  ctx.fillRect(7.5, 13.5, 2.5, 3);
  ctx.fillRect(15.5, 11.5, 2.5, 3);

  ctx.restore();

  return canvas.toDataURL('image/png', 1.0);
};
